import { useUrlState } from "../../hooks";
import { CategoryPage } from "./CategoryPage";
import { HomePage } from "./HomePage";
import "./index.scss";
import { SolutionProps } from "./types";

export const Solution = ({
  rawData,
  currentTestId,
  selectedFilters,
}: SolutionProps) => {
  const {
    updatePath,
    path: { category },
  } = useUrlState();

  function navigateBackToHome() {
    updatePath({ category: undefined, cubeSide: undefined });
  }

  return (
    <div className="solution-module">
      {category ? (
        <CategoryPage
          category={category}
          onHomeClick={navigateBackToHome}
          rawData={rawData}
          currentTestId={currentTestId}
          selectedFilters={selectedFilters}
        />
      ) : (
        <HomePage
          rawData={rawData}
          currentTestId={currentTestId}
          selectedFilters={selectedFilters}
        />
      )}
    </div>
  );
};
